import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

export default class extends Controller {
  static targets = ["confirmation"]
  static values = { redirectUrl: String }

  connect() {
    this.boundEscape = this.handleEscape.bind(this)
    document.addEventListener("keydown", this.boundEscape, { capture: true })
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundEscape, { capture: true })
  }

  handleEscape(event) {
    if (event.key !== "Escape") return
    const content = this.element.closest("[data-dialog-target='content']")
    if (!content || content.classList.contains("hidden")) return
    event.stopImmediatePropagation()
    this.attemptClose()
  }

  attemptClose() {
    this.confirmationTarget.classList.remove("hidden")
  }

  cancelClose() {
    this.confirmationTarget.classList.add("hidden")
  }

  discard() {
    if (this.hasRedirectUrlValue) {
      Turbo.visit(this.redirectUrlValue)
      return
    }

    this.confirmationTarget.classList.add("hidden")
    const content = this.element.closest("[data-dialog-target='content']")
    if (content) {
      content.classList.add("hidden")
      content.classList.remove("flex")
      document.body.style.overflow = ""
    }
  }
}
